/**
 * An object containing filter properties
 */
var Filter = /** @class */ (function () {
    function Filter() {
    }
    return Filter;
}());
export { Filter };
//# sourceMappingURL=filter.js.map